<div class="out" #outComponentha>

  <div class="slot" *ngFor="let slot of t_lbls;let i = index"  kzLib (click)="sel(i)">
    <div class="check" [ngClass]="{selected:checked[i]}"></div> {{slot}}
  </div>
</div>
